<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: {
    show: Boolean,
    data: Object,
    mode: {
      type: String,
      default: "add",
    },
  },

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      form: {
        idverif_soal_tindakan: null,
        nama_tindakan: "",
      },
    };
  },

  watch: {
    modalShow(val) {
      if (val) {
        // 👉 modal OPENED
        if (this.mode === "edit" && this.data) {
          this.form = { ...this.data };
        } else {
          this.resetForm();
        }
      } else {
        // 👉 modal CLOSED
        this.resetForm();
      }
    }
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  methods: {
    resetForm() {
      this.form = {
        idverif_soal_tindakan: null,
        nama_tindakan: "",
      };

    },

    store() {
      if (!this.form.nama_tindakan) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Jenis tindakan tidak boleh kosong.",
          showConfirmButton: true,
        });

        return;
      }

      const url =
        this.mode === "edit"
          ? this.BACKEND_URL_VERSION + "verifikasi/tindakan-soal/" + this.form.idverif_soal_tindakan
          : this.BACKEND_URL_VERSION + "verifikasi/tindakan-soal";

      const method = this.mode === "edit" ? "put" : "post";

      axios({
        method,
        url,
        data: this.form,
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          console.log(res);
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text:
              this.mode === "edit"
                ? "Data berhasil diperbarui"
                : "Data berhasil disimpan",
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          });
          

          this.$emit("close");
          // reload table
          this.$emit("finish"); 
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text: err.response?.data?.data?.message || "Terjadi kesalahan.",
          });
        });
    }, // end of store
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    title="Tambah / Edit Tindakan Soal"
    size="md"
    hide-footer
  >
    <b-form @submit.prevent="store">
      <b-form-group label="Jenis Tindakan" class="fw-medium">
        <b-form-input v-model="form.nama_tindakan"></b-form-input>
      </b-form-group>

      <div class="text-end mt-3">
        <b-button variant="secondary" class="me-2" @click="$emit('close')">
          Batal
        </b-button>
        <b-button type="submit" variant="primary"> Simpan </b-button>
      </div>
    </b-form>
  </b-modal>
</template>